import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getRebalance } from "../../Redux/Actions/transactionService";
import { GetUserInfo } from "../../Redux/Actions/userStatusService";
import OrdersTable from "../Tables/OrdersTable";
import AllOrderTable from '../Tables/AllOrderTable';
import RebalanceOrderTable from '../Tables/RebalanceOrderTable';

function Index() {
  const dispatch = useDispatch();
  const [value, setValue] = useState("investor");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const { users } = useSelector((state) => state.userStatus);
  const userInfoString = localStorage.getItem("userInfo");
  const userInfo = userInfoString && userInfoString !== "undefined" ? JSON.parse(userInfoString) : null;
  const portal = userInfo?.portal || 'MANAGER';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let userInfoResponse = null;
        let entityId = null;

        // Get user info and entity ID
        if (portal?.toLowerCase() === "manager") {
          userInfoResponse = await dispatch(
            GetUserInfo({ role: portal })
          ).unwrap();
        } else if (users && users.length > 0) {
          const parent = users[0]?.parentUserRole?.id;

          if (parent) {
            userInfoResponse = await dispatch(
              GetUserInfo({ role: portal, id: parent })
            ).unwrap();
          }
        }
        entityId = userInfoResponse?.data?.entityInfo?.id;
        
        if (entityId) {
          const additionalParams =
            portal?.toLowerCase() === "sub_manager" && users && users.length > 0
              ? { parent: users[0]?.parentUserRole?.id }
              : {};

          // Fetch orders based on the selected tab
          await dispatch(
            getRebalance({
              ...additionalParams,
            })
          ).unwrap();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, portal, value]); // Added value to dependencies

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid item xs={12}>
        {/* Header Section */}
        <div className="row rows" style={{ marginLeft: "2px" }}>
          <div className="col-9" style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "20px", color: "#18275A", fontWeight: "700" }}>Orders</p>
          </div>
        </div>

        {/* Updated Radio Button Style to match Design 1 */}
        <Box sx={{ 
          width: "100%", 
          display: "flex",
          gap: 2,
          marginTop: "20px"
        }}>
          <Paper
            sx={{
              p: 3,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "250px",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e0e0e0"
            }}
            onClick={() => setValue("investor")}
          >
            <input
              type="radio"
              checked={value === "investor"}
              onChange={() => setValue("investor")}
              style={{ 
                width: "20px", 
                height: "20px",
                cursor: "pointer"
              }}
            />
            <span style={{ fontSize: "16px" }}>Investor's Orders</span>
          </Paper>

          <Paper
            sx={{
              p: 3,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "300px",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e0e0e0"
            }}
            onClick={() => setValue("manager")}
          >
            <input
              type="radio"
              checked={value === "manager"}
              onChange={() => setValue("manager")}
              style={{ 
                width: "20px", 
                height: "20px",
                cursor: "pointer"
              }}
            />
            <span style={{ fontSize: "16px" }}>Investor's Manager Discretion Orders</span>
          </Paper>

          <Paper
            sx={{
              p: 3,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "250px",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e0e0e0"
            }}
            onClick={() => setValue("rebalancing")}
          >
            <input
              type="radio"
              checked={value === "rebalancing"}
              onChange={() => setValue("rebalancing")}
              style={{ 
                width: "20px", 
                height: "20px",
                cursor: "pointer"
              }}
            />
            <span style={{ fontSize: "16px" }}>Rebalancing Orders</span>
          </Paper>
        </Box>
      </Grid>

      {/* Content Section */}
      <Grid item xs={12} style={{ marginTop: "25px" }}>
        <div style={{ height: "auto", overflowY: "visible", overflowX: "hidden" }}>
          {value === "investor" && <AllOrderTable />}
          {value === "manager" && <OrdersTable selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders} />}
          {value === "rebalancing" && <RebalanceOrderTable />}
        </div>
      </Grid>
    </>
  );
}

export default Index;
